import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=62893b30"
import script from "./page-title.vue?vue&type=script&setup=true&lang=ts"
export * from "./page-title.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./page-title.vue?vue&type=style&index=0&id=62893b30&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports